import { PropsWithChildren } from "react";
import classNames from "classnames/bind";
import { SizeContextProvider } from "./SizeContext";
import styles from "./SizeList.module.scss";

const cx = classNames.bind(styles);

type SizeListProps = {
  name?: string;
  label?: string;
  sublabel?: string | null;
  onClick?: (value: string) => void;
  hideLabel?: boolean;
  className?: string;
  longestLabel?: string;
  selectedLabel?: string;
  containerClassName?: string;
  containerProps?: {
    id?: string;
    name?: string;
  };
  brand?: string;
  hasDiorPromosEnabled?: boolean;
  headingLevel?: "h2" | "h3" | "h4" | "h5" | "h6";
};

type SelectorLabelProps = {
  label: string;
  sublabel?: string | null;
  selectedLabel: string;
  headingLevel: "h2" | "h3" | "h4" | "h5" | "h6";
};

export const SizeList = ({
  children,
  name = "size",
  sublabel = "",
  label = "Size",
  onClick = () => {},
  hideLabel = false,
  className = "",
  longestLabel,
  selectedLabel,
  containerClassName,
  containerProps = {},
  brand = "",
  hasDiorPromosEnabled = false,
  headingLevel: Heading = "h4",
}: PropsWithChildren<SizeListProps>) => {
  const renderedLabel = selectedLabel ? (
    <SelectorLabel
      headingLevel={Heading}
      label={label}
      selectedLabel={selectedLabel}
      sublabel={sublabel}
    />
  ) : (
    <Heading className={styles.sizeList__title} data-testid="sizelist:label">
      {label}
    </Heading>
  );

  return (
    <div
      className={cx(styles.sizeList, containerClassName)}
      {...containerProps}
      data-jlds={true}
    >
      {hideLabel ? null : <span>{renderedLabel}</span>}
      <ul className={cx(styles.sizeList__items, className)}>
        <SizeContextProvider
          value={{ name, onClick, longestLabel, brand, hasDiorPromosEnabled }}
        >
          {children}
        </SizeContextProvider>
      </ul>
    </div>
  );
};

const SelectorLabel = ({
  label = "Size",
  headingLevel: Heading = "h4",
  sublabel = "",
  selectedLabel,
}: SelectorLabelProps) => (
  <Heading className={styles.sizeList__title} data-testid="sizelist:label">
    <span className={styles.sizeList__label}>{`${label}: `}</span>
    <span className={styles.sizeList__selected}>{selectedLabel}</span>
    {sublabel && <span className={styles.sizeList__subLabel}> {sublabel}</span>}
  </Heading>
);
